var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "svg",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        key: "loading",
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 100 100",
          preserveAspectRatio: "xMidYMid"
        }
      },
      [
        _c(
          "path",
          {
            attrs: {
              d: "M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50",
              fill: "#0a0a0a",
              stroke: "none",
              transform: "rotate(189.078 50 51)"
            }
          },
          [
            _c("animateTransform", {
              attrs: {
                attributeName: "transform",
                type: "rotate",
                dur: "1.0638297872340425s",
                repeatCount: "indefinite",
                keyTimes: "0;1",
                values: "0 50 51;360 50 51"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d6464f6", { render: render, staticRenderFns: staticRenderFns })
  }
}